// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f1e1d593","239":"b9b5a112","453":"ed855dc0","667":"fdc5c2a2"}[chunkId] + ".chunk.js";
};